import { Alert, List, Stack, Text, Title } from '@mantine/core';

export const ChangePassword = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Change Password</Title>

            <Alert color="yellow" title="SSO Users" mb="sm">
                If you sign in through your organization's Single Sign-On (SSO) provider, you cannot change your password here.
                Please contact your organization's IT administrator to change your password.
            </Alert>

            <Text>The steps below apply only to users who sign in with a username and password directly. You may need to change your password in two situations:</Text>

            <Title order={4} td="underline">Required Password Change</Title>

            <Text>If your administrator has set a temporary password for your account, you will be asked to change it on your next sign-in. You cannot skip this step.</Text>

            <Title order={4} td="underline">How to Change Your Password</Title>

            <List type="ordered" spacing="sm">
                <List.Item>Enter your current (or temporary) password</List.Item>
                <List.Item>Enter your new password</List.Item>
                <List.Item>Confirm your new password</List.Item>
                <List.Item>Click "Change Password"</List.Item>
            </List>

            <Title order={4} td="underline">Password Requirements</Title>

            <List spacing="sm">
                <List.Item>Your new password must meet your organization's password policy</List.Item>
                <List.Item>You cannot reuse your current password</List.Item>
            </List>
        </Stack>
    );
};
